import Vue from 'vue'
// import VueMarkdown from 'vue-markdown'
import BootstrapVue from 'bootstrap-vue'
import VueI18n from 'vue-i18n/dist/vue-i18n.esm.js'

import App from './App.vue'

import {formatDate, formatDateTime, formatMoney, formatNumber, formatText, timeAgo} from './utils/formatter.js'
import storeBuilder from './storeBuilder.js'
import router from './router.js'
import {ENTRYPOINT} from './config/entrypoint.js'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)
// Vue.component('vue-markdown', VueMarkdown)
Vue.use(BootstrapVue)
Vue.use(VueI18n)


Vue.filter('formatDate', formatDate)
Vue.filter('formatDateTime', formatDateTime)
Vue.filter('formatMoney', formatMoney)
Vue.filter('formatNumber', formatNumber)
Vue.filter('formatText', formatText)
Vue.filter('timeAgo', timeAgo)

storeBuilder(ENTRYPOINT).then((store) => {
  const i18n = new VueI18n({
    locale: store.getters['locale'],
    fallbackLocale: 'en',
    messages: {
      en: require('./i18n/en.json')
    }
  })

  new Vue({
    el: '#app',
    store,
    router,
    i18n,
    render: h => h(App)
  })
})

import './sass/main.scss'
